import { ApolloClient, InMemoryCache, createHttpLink, from } from "@apollo/client"
import { onError } from "@apollo/client/link/error"
import { setContext } from "@apollo/client/link/context"
import { generateApiHeaders } from "./crypto"
import { toast } from "@/hooks/use-toast"

const httpLink = createHttpLink({
  uri: import.meta.env.VITE_GRAPHQL_ENDPOINT || "https://api2.myl.cl/graphql",
})

// 🔒 Auth link — agrega el token si existe
const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("authTokenMyL")
  const customHeaders = generateApiHeaders()

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
      ...customHeaders,
    },
  }
})

// ❌ Manejo de errores globales
const errorLink = onError(({ graphQLErrors, networkError }) => {
  let unauthorized = false

  // Detecta errores 401 u otros mensajes de expiración

  if (graphQLErrors) {
    for (const err of graphQLErrors) {
      if (err.extensions?.code === "UNAUTHENTICATED" || /token/i.test(err.message)) {
        unauthorized = true
      }
    }
  }

  if (unauthorized) {
    // Elimina token y muestra aviso
    localStorage.removeItem("authTokenMyL")
    toast({
      title: "Sesión expirada",
      description: "Por favor, inicia sesión nuevamente.",
      variant: "destructive",
    })
    setTimeout(() => {
      window.location.reload()
    }, 4000)
  }
})

// 🧠 Crear cliente Apollo
export const apolloClient = new ApolloClient({
  link: from([errorLink, authLink.concat(httpLink)]),
  cache: new InMemoryCache(),
  name: "myl-web-2025",
  version: "1.0.0",
  defaultOptions: {
    watchQuery: { errorPolicy: "all" },
    query: { errorPolicy: "all" },
  },
})
